import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { init, replayIntegration, browserTracingIntegration } from "@sentry/remix";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

declare global {
  interface Window {
    ENV: {
      SENTRY_DSN: string;
    };
  }
}

init({
  dsn: window.ENV?.SENTRY_DSN,
  tracesSampleRate: 1,
  enableLogs: true,

  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  sendDefaultPii: true,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});
